export default "__VITE_ASSET__S_hV3IdM__"